<template>
  <div>
    <el-popover :width="anchoPopover" trigger="click" :placement="windowWidth < 400 ? 'bottom' : 'bottom-end' "
      popper-class="popover-page" :teleported="false" append-to=".options-right-navbar" @show="lote_id = null"
      v-if="isCliente">

      <template #reference>
        <el-badge :value="disponibilidad" type="primary" badge-class="badge-page ">
          <section class="content-reference">
            <b-img :src="IconPaper" class="px-0" />
          </section>
        </el-badge>
      </template>

      <section class="content-popover ">
        <header>
          <h3 class="fst-italic text-primary">Comprar Páginas</h3>
        </header>

        <main>
          <section class="listado-lotes">
            <ul class="">
              <li v-for="(lote) in lotes" :key="lote.id" class="lote-item" @click="seleccionarLote(lote.id)"
                :class="{'active' : lote_id === lote.id}">
                <section class="descripcion-content-item">
                  <h4>
                    {{ lote.descripcion }}
                  </h4>
                  <strong class="text-danger" v-if="lote.descuento > 0">
                    Descuento del {{ lote.descuento }} %
                  </strong>
                </section>
                <section class="precio-content-item">
                  <span>
                    {{ currency(lote.monto) }}
                  </span>
                  <small v-if="lote.precio_por_pag">
                    {{ lote.precio_por_pag }} / Pág.
                  </small>
                </section>
              </li>
            </ul>
          </section>

          <strong class="text-center mx-0 d-inline-block w-100 mb-1 text-center cursor-pointer text-comprar-mas"
            @click="mostrarFormCompraPaginas">
            Puedes comprar las cantidades que necesites.
          </strong>

          <b-button variant="primary" title="Comprar Página" class="w-100 mb-1" :disabled="!lote_id"
            @click="showDialogPago = true">
            Comprar páginas
          </b-button>
        </main>
      </section>

    </el-popover>

    <el-dialog v-model="showDialogPago" :width="anchoSidebar" @opened="montarButtonPaypal"
      header-class="bg-secondary text-white py-1 text-white" class="p-0" align-center :close-on-click-modal="false" body-class="px-1"
      destroy-on-close>
      <template #header>
        <section class="px-1 text-white">
          <h3 class="text-white">Comprar lote de páginas</h3>
        </section>
      </template>
      <main class="contenido-plan mx-auto p-1">
        <header>
          <h3 class="fst-bolder fs-2">{{ lote_comprar.descripcion }}</h3>
        </header>

        <section class="d-flex flex-column justify-content-around">
          <article class="d-flex align-items-center justify-content-center  my-1 flex-grow-0 flex-wrap text-center">
            <h2 class="my-0 lh-1 py-0 fs-1 fst-italic text-primary " style="text-decoration: underline;">{{
              currency(monto_lote) }}</h2>
          </article>

          <article class="mt-1 flex-grow-1">
            <p class="lh-sm" style="font-size:10pt !important;">{{ lote_comprar.label }}</p>
          </article>

        </section>

      </main>
      <footer class="button-paypal">
        <div id="paypal-button-container"></div>
      </footer>

    </el-dialog>
  </div>
</template>

<script setup>
import useUsuarioStore from '@/store/usuario';
import useUtils from '@/composables/useUtils';
import useLoteStore from '@/store/lote';
import { useForm } from 'vee-validate';

import {required} from '@validations';

import useRootStore from '@/store/root';
import useSistemaStore from '@/store/sistema';

import useAppStore from '@/store/app';
import useCompraStore from '@/store/compra';
import { loadScript } from '@paypal/paypal-js'; 
import IconPaper from '@images/paper.png'
import PageIllustration  from '@images/illustration/pages.svg';
import { currency } from '@/utils/utils';
import { BFormSpinbutton } from 'bootstrap-vue-next';
const usuario_store = useUsuarioStore();
const { usuario,isCliente } = storeToRefs(usuario_store);
const paginas = computed(() => usuario.value.paginas || 0);
const app_store = useAppStore();
const lote_store = useLoteStore();
const showDialogPago = ref(false);
const lote_comprar = ref(null);
const monto_lote = ref(0);

const sistema_store = useSistemaStore();
const { sistema } = storeToRefs(sistema_store);

const {
  datos_paypal
} = useUtils();

const lotes = ref([]);
const lote_id = ref(null);

const { isScreenMovil, windowWidth, anchoSidebar } = storeToRefs(app_store);

const disponibilidad = computed(() => {
  return paginas.value > 0 ? `${paginas.value} Páginas` : 'Sin Páginas';
});

const showFormCompraPaginas = inject('showFormCompraPaginas');

const anchoPopover = computed(() => {
  if(windowWidth.value < 640){
    return 290;
  }else if(windowWidth.value < 992){
    return 350;
  }else{
    return 420;
  }
})


const { defineField,handleSubmit,resetForm,setErrors,errors } = useForm({
  initialValues:{
    cant_paginas:1,
  },
  validationSchema: {
    cant_paginas:required
  }
});

const [cant_paginas,cant_paginas_attrs] = defineField('cant_paginas');

const cargarLotes = () => {
  if(usuario.value.id) {
    lote_store.fetchListSelect()
      .then((lts) => {
        lotes.value = lts;
      })
  }
  
}

watch(() => usuario.value.id, () => {
  cargarLotes();
})

onMounted(() => {
  cargarLotes();
});


const seleccionarLote = (id)  => {
  let lot = lotes.value.find(l => l.id === id);
  if(lot){
    lote_comprar.value = lot;
    monto_lote.value = lot.monto;
    lote_id.value = lot.id;
  }
}


const paypalExitoso = (data) => {
  const compra_store = useCompraStore();

  compra_store.comprarLote({
    lote_id: lote_id.value,
    monto: monto_lote.value,
    descripcion:lote_comprar.value.label,
    paypal_data: data
  }).then(({ result }) => {
    if (result) {
      usuario_store.refetchUsuario(usuario.value.id);
      showDialogPago.value = false;
      swal({
        title: 'Pago exitoso',
        text: `Has comprado el lote de páginas exitosamente.`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    }

  }).catch((e) => {
    console.log(e)
  })
}



const clienteNoQuisoPagar = () => {
  // toast.info("El cliente no quiso pagar");
}

const mostrarFormCompraPaginas = () => {
  showFormCompraPaginas.value = true;
}



const montarButtonPaypal = () => {


  loadScript(datos_paypal.value)
    .then((paypalObject) => {
      if (paypalObject) {

        paypalObject.Buttons({
          onApprove: paypalExitoso,
          onCancel: clienteNoQuisoPagar,
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{
                
                amount: {
                  value: String(monto_lote.value), // el total
                  currency_code: 'USD',
                  breakdown: {
                    item_total: {
                      value: String(monto_lote.value),
                      currency_code: 'USD'
                    }
                  }
                },

                items: [
                  {
                    name: lote_comprar.value.descripcion,
                    description: lote_comprar.value.descripcion,
                    unit_amount: {
                      value: String(monto_lote.value),
                      currency_code: 'USD'
                    },
                    quantity: '1'
                  }
                  // Puedes agregar más items aquí si lo necesitas
                ]
              }]
            });
          }
        }).render('#paypal-button-container');
      }
    })
    .catch(error => {
      console.error('Error loading PayPal script:', error);
    });
}



</script>

<style lang="scss" scoped>
@import '@variables/variables';

:deep(.badge-page){
  margin-left: 0px;
  right: 80px;
  top: -8px;
}

.content-reference{
  // margin-right:20px;
  img{
    width:40px;
    cursor:pointer;
    &:hover{
      // box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.5);
    }
  }
}



  

  .content-popover {
    main {

    
        .listado-lotes {
    
          max-height: 380px !important;
          overflow-y: scroll !important;
          padding-right:10px;

          display:flex;
          flex-direction: column;
          align-items: flex-start;
          ul{
            text-decoration: none;
            padding: 0px;
            width: 100% !important;
          
            li {
              list-style: none !important;
              &.lote-item {
                height: 100px !important;
                display:flex;
                justify-content: space-between;
                border: 2px solid black;
                margin:1rem 0px;
                padding: .5rem;
                border-radius: 10px;
                width:100% !important;
                position:relative;
                &:hover{
                  box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.5);
                  cursor:pointer;
                }

                &.active{
                  border:5px solid $secondary;

                  &::after{
                    content:'Seleccionado';
                    position: absolute;
                    top: -18px;
                    background-color: $primary;
                    width:fit-content;
                    padding: 5px 10px;
                    border-radius: 10px;
                    color: white !important;
                  }
                }


                .descripcion-content-item{
                  flex:1 1 70%;
                  display:flex;
                  flex-direction: column;
                  justify-content: center;
                  padding-right:5px;
                  h4{
                    color:$dark;
                    font-size:10pt;

                    @media (min-width:640px){
                      font-size:16pt;
                    }
                  }

                  strong{
                    color:$danger ;
                    font-size:12pt;
                  }
                }

                .precio-content-item{
                  flex:0 0 30%;
                  display:flex;
                  flex-direction: column;
                  justify-content: center;

                  span{
                    font-size:10pt;
                    font-weight: bold;
                    color: $primary;
                    align-self: center;

                    @media (min-width:640px) {
                      font-size: 14pt;
                    }
                  }
                  small{
                    font-size:6pt;
                    align-self: center;
                    @media (min-width:640px) {
                        font-size: 8pt;
                    }
                  }
                }
              }
            }
          }
        }

        .text-comprar-mas{
          font-size:12pt;

          &:hover{
            text-decoration: underline;
            color: $primary;
          }

          @media (min-width:640px) {
            font-size: 14pt;
          }
        }
      }
   }

.contenido-plan {
  width: calc(100% - 0rem);
  margin: .5rem 0rem;
  height: auto;
  position: relative;
  overflow: hidden;
  border: .3px solid rgba(0, 0, 0, .1);
  padding: 0px;

  .badge-subscrito {
    position: absolute;
    width: auto;
    top: 5px;
    right: 5px;
    background-color: $secondary;
    padding: 5px 20px;
    color: white;
    font-style: bold;
    border-radius: 20px;
    font-size: 12pt;
  }

  &.active,
  &:hover {
    border: 1px solid $primary;
    box-shadow: 5px 5px 10px 3px rgba(0, 0, 0, .4);
  }

  .list-beneficios {
    flex-grow: 1;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-height: 200px;
  }

  .btn-action {
    height: 44px;
    display: flex;
    justify-content: center;

    svg {
      margin-left: 1rem;
    }
  }

  span {
    font-size: 10pt;
  }

  p {
    font-size: 12pt !important;
  }

  .btn-show-opcion {
    position: absolute;
    // z-index: 100;
    top: 1rem;
    right: 1rem;
    left: auto;
    height: 20px;
    width: 20px;
    padding: 0px;

    &:hover {
      background-color: rgba(0, 0, 0, .1);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, .2);

      i,
      svg {
        color: $secondary;
      }
    }
  }

  .opciones-card {
    position: absolute;
    height: 100%;
    width: 80%;
    top: 0;
    right: -80%;
    z-index: 101;
    transition: 60ms ease-in-out;
    background-color: $dark;

    h4 {
      color: white;
    }

    &.show {
      right: 0;
    }

    .card-bio-acciones {
      display: flex;
      justify-content: center;
    }
  }

  @media (min-width:692px) {
    width: calc(100% / 2 - 1rem) !important;
    margin: .5rem;

    span {
      font-size: 12pt;
    }

    p {
      font-size: 14pt !important;
    }
  }

  @media (min-width:992px) {
    width: 350px !important;
  }
}

.button-paypal {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  #paypal-button-container,
  #paypal-button-container-detal {
    width: 90%;
    @media (min-width: 768px) {
      width: 70%;
    }
  }
}

.precio-total-detal{
  padding: .5rem 1rem;
  width: 90%;

  @media (min-width: 768px) {
    width: 70%;
  }
}



</style>